import Vue from 'vue';
import Vuex from 'vuex';
import calculator from '@/store/calculator';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {
    },
    modules: {
      calculator,
    },
  });
};
